import * as React from "react";

import { Container } from "@material-ui/core";

import { Header } from "client/components";
import { LeadForm, LoginHero, TwoColumnLayout } from "client/domain";

export const Control: React.FC = () => (
  <Container fixed>
    <TwoColumnLayout
      header={<Header />}
      leftColumn={<LoginHero />}
      rightColumn={<LeadForm />}
    />
  </Container>
);
